import {
  FullCalendar,
  FullCalendarCurrentDate,
  FullCalendarDayView,
  FullCalendarMonthView,
  FullCalendarNextTrigger,
  FullCalendarPrevTrigger,
  FullCalendarViewTrigger,
  FullCalendarWeekView,
  FullCalendarYearView,
} from "../../shadcn/components/custom/full-calendar";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const EventsCalendarPage = () => {
  return (
    <div className="pb-4 px-4 lg:px-8 pt-6 relative">
      <FullCalendar>
        <div className="h-dvh flex flex-col">
          <div className="sm:flex justify-between items-center gap-2 mb-6">
            <div className="flex  gap-3 justify-between sm:justify-between">
              <FullCalendarPrevTrigger>
                <ChevronLeft size={20} />
                <span className="sr-only">Previous</span>
              </FullCalendarPrevTrigger>

              <div className="w-full">
                <FullCalendarCurrentDate />
              </div>

              <FullCalendarNextTrigger>
                <ChevronRight size={20} />
                <span className="sr-only">Next</span>
              </FullCalendarNextTrigger>
            </div>

            <div className="flex gap-6 mt-3 sm:mt-0 justify-center sm:justify-between">
              <FullCalendarViewTrigger
                className="aria-[current=true]:bg-accent px-1 py-1 sm:px-3"
                view="day"
              >
                Day
              </FullCalendarViewTrigger>
              <FullCalendarViewTrigger
                view="week"
                className="aria-[current=true]:bg-accent px-1 py-1 sm:px-3"
              >
                Week
              </FullCalendarViewTrigger>
              <FullCalendarViewTrigger
                view="month"
                className="aria-[current=true]:bg-accent px-1 py-1 sm:px-3"
              >
                Month
              </FullCalendarViewTrigger>
              <FullCalendarViewTrigger
                view="year"
                className="aria-[current=true]:bg-accent px-1 py-1 sm:px-3"
              >
                Year
              </FullCalendarViewTrigger>
            </div>
          </div>

          <div className="flex-1 lg:overflow-hidden overflow-auto relative">
            <FullCalendarDayView />
            <FullCalendarWeekView />
            <FullCalendarMonthView />
            <FullCalendarYearView />
          </div>
        </div>
      </FullCalendar>
    </div>
  );
};

export default EventsCalendarPage;
